export default "__VITE_ASSET__Ft9ccYHs__"